import React, { Component, Fragment } from "react";
import ReactTooltip from "react-tooltip";
import { Subject, of } from "rxjs";
import { debounceTime, pairwise } from "rxjs/operators";

import styles from "./Editor.local.scss";

const TOKEN_TYPE_OPERATOR = "Operator";
const TOKEN_TYPE_VARIALBLE = "Variable";
const TOKEN_TYPE_LITERAL = "Literal";
const TOKEN_TYPE_LEFT_PARENTHESIS = "Left_Parenthesis";
const TOKEN_TYPE_RIGHT_PARENTHESIS = "Right_Parenthesis";

class Editor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputFormulaText: this.props.inputFormulaText + " ",
      validFormulaText: null,
      formulaErrors: [],
      suggestion: {
        enabled: false,
        type: TOKEN_TYPE_VARIALBLE,
        searchParam: "",
        part: "",
        cursor: 0
      },
      tokens: [],
      cursor: 0
    };

    // this.inputStream = new Subject();
    this.inputRef = React.createRef();

    // this.parser = new Parser(props.supportedVars.map(indicator => indicator.code));
  }

  componentDidMount() {
    this.parser = new Parser(
      this.props.supportedVars.map(indicator => indicator.code)
    );
    this.inputStream = new Subject();
    this.initializeInputStream();
  }

  componentWillUnmount() {
    this.inputSub.unsubscribe();
  }

  initializeInputStream() {
    this.inputSub = this.inputStream.pipe(debounceTime(50)).subscribe(data => {
      let parser = new Parser(
        this.props.supportedVars.map(indicator => indicator.code)
      );
      let tokens = parser.tokenize(data.value),
        errors = parser.validate(tokens),
        cursor = parser.cursor(data.value, data.cursor),
        lastToken = parser.lastToken(tokens),
        part = lastToken
          ? data.value
              .split(lastToken.value)
              .pop()
              .trim()
          : data.value.trim();

      if (data.enableSuggestion) {
        this.setState(state => {
          return {
            suggestion: {
              ...this.resolveSuggestion(tokens, cursor, data.value),
              cursor: 0
            }
          };
        });
      } else {
        this.disableSuggestion();
      }

      this.setState(state => ({
        inputFormulaText: data.value,
        formulaErrors: errors,
        tokens: tokens,
        cursor: data.cursor
      }));

      if (!errors.length && !part) {
        this.setState(state => {
          let validFormulaText = data.value.trim();
          if (validFormulaText !== state.validFormulaText) {
            this.props.onChange(validFormulaText, state.tokens);
          }

          return {
            validFormulaText
          };
        });
      }

      this.inputRef.current.setSelectionRange(data.cursor, data.cursor);
    });

    if (this.state.inputFormulaText) {
      this.inputStream.next({
        value: this.state.inputFormulaText,
        cursor: this.state.inputFormulaText.length,
        enableSuggestion: false
      });
    }
  }

  disableSuggestion() {
    this.setState(state => {
      return {
        suggestion: { ...state.suggestion, enabled: false }
      };
    });
  }

  resolveSuggestion(tokens, cursor, inputFormula) {
    let currentToken = this.parser.currentToken(tokens, cursor),
      lastToken = this.parser.lastToken(tokens),
      part = lastToken
        ? inputFormula
            .split(lastToken.value)
            .pop()
            .trim()
        : inputFormula.trim();

    if (currentToken) {
      if (currentToken.type === TOKEN_TYPE_VARIALBLE) {
        return {
          enabled: true,
          type: TOKEN_TYPE_VARIALBLE,
          searchParam: currentToken.value,
          part
        };
      }
      if (
        currentToken.type === TOKEN_TYPE_OPERATOR ||
        currentToken.type === TOKEN_TYPE_LEFT_PARENTHESIS
      ) {
        if (currentToken === lastToken) {
          return {
            enabled: true,
            type: TOKEN_TYPE_VARIALBLE,
            searchParam: part,
            part
          };
        } else {
          let currentVar = this.parser.currentVar(tokens, cursor);
          return {
            enabled: true,
            type: TOKEN_TYPE_VARIALBLE,
            searchParam: currentVar ? currentVar.value : "",
            part
          };
        }
      }
      if (currentToken.type === TOKEN_TYPE_RIGHT_PARENTHESIS) {
        return {
          enabled: false
        };
      }
    } else if (lastToken) {
      if (
        lastToken.type === TOKEN_TYPE_OPERATOR ||
        lastToken.type === TOKEN_TYPE_LEFT_PARENTHESIS
      ) {
        return {
          enabled: true,
          type: TOKEN_TYPE_VARIALBLE,
          searchParam: part,
          part
        };
      } else if (
        lastToken.type === TOKEN_TYPE_VARIALBLE &&
        !this.props.supportedVars.map(v => v.code).includes(lastToken.value)
      ) {
        return {
          enabled: true,
          type: TOKEN_TYPE_VARIALBLE,
          searchParam: lastToken.value,
          part
        };
      }

      return {
        enabled: true,
        type: TOKEN_TYPE_OPERATOR,
        searchParam: "",
        part
      };
    }

    return {
      enabled: true,
      type: TOKEN_TYPE_VARIALBLE,
      searchParam: part,
      part
    };
  }

  applySuggestion(suggestion, type) {
    // If we just start typing formula and we don't have any recognized token then the suggestion is itself the formula
    if (!this.state.tokens.length) {
      this.inputStream.next({
        value: suggestion,
        cursor: suggestion.length,
        enableSuggestion: false
      });
      this.inputRef.current.focus();

      return;
    }

    let tokens = [...this.state.tokens],
      cursor = this.parser.cursor(
        this.state.inputFormulaText,
        this.state.cursor
      ),
      currentToken = this.parser.currentToken(tokens, cursor),
      lastToken = this.parser.lastToken(tokens),
      isUpdated = 0,
      recalculatedFormula = "";

    if (currentToken) {
      if (
        type !== currentToken.type &&
        type === TOKEN_TYPE_VARIALBLE &&
        currentToken.value !== lastToken.value
      ) {
        currentToken = this.parser.currentVar(tokens, cursor);
        if (currentToken) {
          currentToken.value = suggestion;
          isUpdated = 1;
        }
      }
    }

    if (type === lastToken.type && lastToken.endPosition < cursor) {
      lastToken.value = suggestion;
      isUpdated = 1;
    }

    tokens.forEach((token, i) => {
      recalculatedFormula += " " + token.value + " ";
    });

    if (!isUpdated) {
      recalculatedFormula += " " + suggestion + " ";
    }

    if (this.state.suggestion.part && isUpdated) {
      recalculatedFormula += " " + this.state.suggestion.part + " ";
    }

    this.inputStream.next({
      value: recalculatedFormula,
      cursor: recalculatedFormula.length - 1,
      enableSuggestion: false
    });

    this.setState(prevState => ({
      suggestion: {
        ...prevState.suggestion,
        cursor: 0
      }
    }));

    this.inputRef.current.focus();
  }

  hasVars() {
    return (
      this.state.tokens.filter(token => token.type === TOKEN_TYPE_VARIALBLE)
        .length !== 0
    );
  }
  getVarLabel(code) {
    const indicators = this.props.supportedVars.filter(
      indicator => indicator.code === code
    );
    if (!indicators.length) {
      return null;
    }

    return (
      indicators[0].label[this.props.language] ||
      indicators[0].label["fr"] ||
      indicators[0].label["nl"] ||
      indicators[0].code
    );
  }

  handleKeyUp(e) {
    let suggestions = [];

    const { cursor } = this.state.suggestion;

    switch (this.state.suggestion.type) {
      case TOKEN_TYPE_VARIALBLE:
        suggestions = this.props.supportedVars.filter(indicator => {
          return (
            indicator.code
              .toLowerCase()
              .includes(this.state.suggestion.searchParam.toLowerCase()) ||
            (indicator.label[this.props.language]
              ? indicator.label[this.props.language]
              : ""
            )
              .toLowerCase()
              .includes(this.state.suggestion.searchParam.toLowerCase())
          );
        });
        break;
      case TOKEN_TYPE_OPERATOR:
        suggestions = this.props.supportedOperators;
        break;
      default:
        break;
    }

    if (e.keyCode === 38 && cursor > 0) {
      this.setState(prevState => ({
        suggestion: {
          ...prevState.suggestion,
          cursor: prevState.suggestion.cursor - 1
        }
      }));
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      this.setState(prevState => ({
        suggestion: {
          ...prevState.suggestion,
          cursor: prevState.suggestion.cursor + 1
        }
      }));
    } else if (e.keyCode === 13) {
      this.applySuggestion(
        suggestions[this.state.suggestion.cursor].code,
        this.state.suggestion.type
      );
    }
  }

  render() {
    return (
      <div
        className={styles.formula_editor}
        onBlur={() => setTimeout(this.disableSuggestion.bind(this), 50)}
      >
        {this.renderErrors()}

        <input
          required
          ref={this.inputRef}
          className={`${styles.formula_editor__input} ${
            this.state.formulaErrors.length
              ? styles.formula_editor__input__error
              : ""
          }`}
          value={this.state.inputFormulaText}
          onChange={e =>
            this.inputStream.next({
              value: e.target.value,
              cursor: e.target.selectionEnd,
              enableSuggestion: true
            })
          }
          onKeyUp={e => this.handleKeyUp(e)}
        />
        <img
          data-for={`info__${this.props.code}`}
          data-tip={""}
          className={styles.formula_editor__info}
          src={"/img/icons/info.svg"}
          alt=""
        />
        {this.hasVars() ? (
          <ReactTooltip
            id={`info__${this.props.code}`}
            type="dark"
            place="left"
          >
            {this.renderFormulaInfo()}
          </ReactTooltip>
        ) : (
          ""
        )}

        {this.renderSuggestion()}
      </div>
    );
  }

  renderErrors() {
    if (!this.state.formulaErrors.length) {
      return "";
    }

    return (
      <div className={styles.formula_editor__errors}>
        {this.state.formulaErrors.map((error, i) => (
          <span key={i}> {`${error.token.value} : ${error.message}`} </span>
        ))}
      </div>
    );
  }

  renderFormulaInfo() {
    return (
      <Fragment>
        {this.state.tokens
          .filter(token => token.type === TOKEN_TYPE_VARIALBLE)
          .map((token, i) => (
            <div key={i}>{`${token.value}: ${this.getVarLabel(token.value) ||
              "Unsupported variable"}`}</div>
          ))}
      </Fragment>
    );
  }

  renderSuggestion() {
    if (!this.state.suggestion.enabled) {
      return "";
    }

    if (this.state.suggestion.type === TOKEN_TYPE_OPERATOR) {
      return (
        <div className={styles.formula_editor__suggestion}>
          <section>
            {this.props.supportedOperators.map((operator, i) => (
              <span
                key={i}
                className={
                  this.state.suggestion.cursor === i
                    ? `${styles.formula_editor__suggestion_item} ${
                        styles.item__active
                      }`
                    : styles.formula_editor__suggestion_item
                }
                onClick={() =>
                  this.applySuggestion(operator.code, TOKEN_TYPE_OPERATOR)
                }
              >
                {" "}
                {`${operator.code} :  ${operator.label}`}{" "}
              </span>
            ))}
          </section>
        </div>
      );
    }
    if (this.state.suggestion.type === TOKEN_TYPE_VARIALBLE) {
      return (
        <div className={styles.formula_editor__suggestion}>
          <section>
            {this.props.supportedVars
              .filter(indicator => {
                // @todo sanitize... (minor)
                return (
                  indicator.code
                    .toLowerCase()
                    .includes(
                      this.state.suggestion.searchParam.toLowerCase()
                    ) ||
                  (indicator.label[this.props.language]
                    ? indicator.label[this.props.language]
                    : ""
                  )
                    .toLowerCase()
                    .includes(this.state.suggestion.searchParam.toLowerCase())
                );
              })
              .map((indicator, i) => (
                <span
                  key={i}
                  className={
                    this.state.suggestion.cursor === i
                      ? `${styles.formula_editor__suggestion_item} ${
                          styles.item__active
                        }`
                      : styles.formula_editor__suggestion_item
                  }
                  onClick={() =>
                    this.applySuggestion(indicator.code, TOKEN_TYPE_VARIALBLE)
                  }
                >
                  {`[${indicator.code}] ${indicator.label[
                    this.props.language
                  ] || indicator.label.fr}`}
                </span>
              ))}
          </section>
        </div>
      );
    }
  }
}

Editor.defaultProps = {
  language: "fr",
  inputFormulaText: "",
  onChange: () => {},
  supportedVars: [],
  supportedOperators: [
    {
      code: "+",
      label: "Ajouter"
    },
    {
      code: "-",
      label: "Soustraire"
    },
    {
      code: "*",
      label: "Multiplier"
    },
    {
      code: "/",
      label: "Diviser"
    },
    {
      code: "(",
      label: "Left parenthesis"
    },
    {
      code: ")",
      label: "Right parenthesis"
    }
  ]
};

class Parser {
  constructor(supportedVars) {
    this.supportedVars = supportedVars;
  }

  cursor(str, cursor) {
    return (
      cursor -
      (str.substring(0, cursor).length -
        str.substring(0, cursor).replace(/\s+/g, "").length)
    );
  }

  currentToken(tokens, cursor) {
    let resultTokens = tokens.filter(
      token => token.startPosition <= cursor && token.endPosition >= cursor
    );
    if (!resultTokens.length) {
      return null;
    }

    return resultTokens[0];
  }

  currentVar(tokens, cursor) {
    let token = this.currentToken(tokens, cursor);

    if (!token || !cursor || token.type === TOKEN_TYPE_VARIALBLE) {
      return token;
    }

    return this.currentVar(tokens, cursor - 1);
  }

  lastToken(tokens) {
    return tokens[tokens.length - 1] || null;
  }

  tokenize(str) {
    // str = str.replace(/\s+/g, "");
    let arr = str.split(""),
      result = [],
      numberBuffer = [],
      varBuffer = [],
      cursor = 0;

    arr.forEach((char, idx) => {
      if (this.isDigit(char) || this.isComma(char)) {
        if (0 === varBuffer.length) {
          numberBuffer.push(char);
        } else {
          varBuffer.push(char);
        }
      } else if (this.isLetter(char)) {
        varBuffer.push(char);
      } else if (this.isOperator(char)) {
        if (0 !== varBuffer.length) {
          if (
            result[result.length - 1] &&
            result[result.length - 1].type === TOKEN_TYPE_VARIALBLE
          ) {
            result[result.length - 1].value += " " + this.concat(varBuffer);
          } else {
            result.push({
              type: TOKEN_TYPE_VARIALBLE,
              value: this.concat(varBuffer)
            });
          }
          varBuffer = [];
        }
        if (0 !== numberBuffer.length) {
          result.push({
            type: TOKEN_TYPE_LITERAL,
            value: this.concat(numberBuffer)
          });
          numberBuffer = [];
        }
        result.push({ type: TOKEN_TYPE_OPERATOR, value: char });
      } else if (this.isLeftParenthesis(char)) {
        result.push({ type: TOKEN_TYPE_LEFT_PARENTHESIS, value: char });
      } else if (this.isRightParenthesis(char)) {
        result.push({ type: TOKEN_TYPE_RIGHT_PARENTHESIS, value: char });
      } else {
        if (0 !== varBuffer.length) {
          if (
            result[result.length - 1] &&
            result[result.length - 1].type === TOKEN_TYPE_VARIALBLE
          ) {
            result[result.length - 1].value += " " + this.concat(varBuffer);
          } else {
            result.push({
              type: TOKEN_TYPE_VARIALBLE,
              value: this.concat(varBuffer)
            });
          }
          varBuffer = [];
        }
        if (0 !== numberBuffer.length) {
          result.push({
            type: TOKEN_TYPE_LITERAL,
            value: this.concat(numberBuffer)
          });
          numberBuffer = [];
        }
      }

      let lastToken = result[result.length - 1];
      if (lastToken && !lastToken.startPosition && !lastToken.endPosition) {
        lastToken.startPosition = cursor;
        lastToken.endPosition = (cursor = cursor + lastToken.value.length) - 1;
        result[result.length - 1] = lastToken;
      }
    });

    return result;
  }

  validate(tokens) {
    let errors = [];
    let leftParenthesisCount = 0,
      rightParenthesisCount = 0;

    if (!tokens.length) {
      errors.push({
        token: { value: '""' },
        message: "Can't be empty"
      });
    }

    if (tokens.length && TOKEN_TYPE_OPERATOR === tokens[0].type) {
      errors.push({
        token: { value: "+-/*" },
        message: "Can't start with an operator"
      });
    }

    if (
      tokens.length &&
      TOKEN_TYPE_OPERATOR === tokens[tokens.length - 1].type
    ) {
      errors.push({
        token: { value: "+-/*" },
        message: "Can't finish with an operator"
      });
    }

    tokens.forEach(token => {
      if (
        token.type === TOKEN_TYPE_VARIALBLE &&
        !this.supportedVars.includes(token.value)
      ) {
        errors.push({
          token: token,
          message: "Unsupported variable"
        });
      } else if (
        token.type === TOKEN_TYPE_LITERAL &&
        !/^-?\d+(?:[.,]\d*?)?$/.test(token.value)
      ) {
        errors.push({
          token: token,
          message: "Unsupported number"
        });
      } else if (token.type === TOKEN_TYPE_RIGHT_PARENTHESIS) {
        rightParenthesisCount++;
      } else if (token.type === TOKEN_TYPE_LEFT_PARENTHESIS) {
        leftParenthesisCount++;
      }
    });

    if (leftParenthesisCount !== rightParenthesisCount) {
      errors.push({
        token: { value: "( / )" },
        message: "Missed parenthesis"
      });
    }

    of(...tokens)
      .pipe(pairwise())
      .subscribe(pair => {
        if (
          pair[0].type === pair[1].type &&
          ![TOKEN_TYPE_LEFT_PARENTHESIS, TOKEN_TYPE_RIGHT_PARENTHESIS].includes(
            pair[0].type
          )
        ) {
          errors.push({
            token: { value: `(${pair[0].value},${pair[1].value})` },
            message: "Invalid consecutive parameters"
          });
        }
      });

    return errors;
  }

  concat(buffer) {
    if (!buffer.length) {
      return "";
    }
    return buffer.reduce((previousVal, currentVal) => previousVal + currentVal);
  }

  isComma(ch) {
    return ch === "," || ch === ".";
  }

  isDigit(ch) {
    return /\d/.test(ch);
  }

  isLetter(ch) {
    // return /[a-z]|#/i.test(ch);
    return (
      !/\s+/g.test(ch) &&
      !this.isOperator(ch) &&
      !this.isDigit(ch) &&
      !this.isComma(ch) &&
      !this.isLeftParenthesis(ch) &&
      !this.isRightParenthesis(ch)
    );
  }

  isOperator(ch) {
    return /\+|-|\*|\//.test(ch);
  }

  isLeftParenthesis(ch) {
    return ch === "(";
  }

  isRightParenthesis(ch) {
    return ch === ")";
  }
}

export default Editor;



// WEBPACK FOOTER //
// ./src/components/Indicator/Editor.js